module.exports = __webpack_public_path__ + "assets/img/includedinotherfra.a0e9369c.svg";